"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.testRegex = exports.NIP_REGEX = exports.PESEL_REGEX = exports.POSTCODE_REGEX = exports.PHONE_STRING_REGEX = exports.PHONE_REGEX = exports.EMAIL_REGEX = exports.SLUG_REGEX = exports.DOUBLE_REGEX = exports.CONFIRM_CODE_REGEX = exports.INT_REGEX = exports.IS_ONE_DIGIT = void 0;
exports.IS_ONE_DIGIT = /^[0-9]$/g;
exports.INT_REGEX = /^[0-9]*?$/;
exports.CONFIRM_CODE_REGEX = /^[0-9]{4}$/;
exports.DOUBLE_REGEX = /^[0-9]*(([,]|[.])([0-9]|[0-9][0-9])?)?$/;
exports.SLUG_REGEX = /^[a-z0-9.]*$/;
exports.EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
exports.PHONE_REGEX = /^\+48\d{9}$/;
exports.PHONE_STRING_REGEX = /^\+48 \d{3} \d{3} \d{3}$/;
exports.POSTCODE_REGEX = /^\d{2}-\d{3}$/;
exports.PESEL_REGEX = /^\d{11}?$/;
exports.NIP_REGEX = /^\d{10}?$/;
const testRegex = (value, regex) => {
    return new RegExp(regex).test(value);
};
exports.testRegex = testRegex;
//# sourceMappingURL=index.js.map